exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  position: relative;\n  top: 80px;\n  background: #ff404e;\n  min-height: 200px;\n  color: white; }\n  footer li {\n    list-style-type: none;\n    display: inline-block;\n    padding: 5px; }\n  footer i {\n    font-size: 1.5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/footer/footer.component.scss
// module id = ../../../../../src/app/pages/footer/footer.component.scss
// module chunks = main